import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const PageRefresh = () => {
  return (
    <div className="flex justify-center items-center w-full h-screen">
      <DotLottieReact
        src="https://lottie.host/f9f69fc1-9ea7-4b96-8566-579d1ad7e5f3/ZaOvC54Foa.lottie"
        loop
        autoplay
        className="size-[150px] md:size-[200px]"
      />
    </div>
  );
};

export default PageRefresh;
